import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MetadataDefinitionApi } from '../../services/ApiService';

function MetadataDefinitionList() {
  const [metadataDefs, setMetadataDefs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadMetadataDefinitions();
  }, []);

  const loadMetadataDefinitions = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await MetadataDefinitionApi.getDocumentMetadataDefinitions();
      if (response.ok) {
        const data = await response.json();
        setMetadataDefs(Array.isArray(data) ? data : []);
      } else {
        throw new Error(`Failed to load metadata definitions: ${response.status}`);
      }
    } catch (err) {
      console.error("Error loading metadata definitions:", err);
      setError(err.message);
      setMetadataDefs([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Are you sure you want to delete the metadata definition "${name}"?`)) {
      return;
    }

    try {
      const response = await MetadataDefinitionApi.deleteDocumentMetadataDefinition(id);
      if (response.ok) {
        // Remove the deleted item from the local state
        setMetadataDefs(prev => prev.filter(def => def.id !== id));
        console.log(`Successfully deleted metadata definition: ${name}`);
      } else {
        const errorText = await response.text();
        throw new Error(`Failed to delete metadata definition: ${response.status} - ${errorText}`);
      }
    } catch (err) {
      console.error("Error deleting metadata definition:", err);
      alert(`Error deleting metadata definition: ${err.message}`);
    }
  };

  if (loading) {
    return <div>Loading metadata definitions...</div>;
  }

  if (error) {
    return (
      <div>
        <h2>Error Loading Metadata Definitions</h2>
        <p style={{ color: 'red' }}>Error: {error}</p>
        <button onClick={loadMetadataDefinitions}>Retry</button>
      </div>
    );
  }

  return (
    <div>
      <h2>Document Metadata Definitions</h2>
      <Link to="/settings/document-metadata-definitions/create">
        Create New Metadata Definition
      </Link>

      {metadataDefs.length === 0 ? (
        <div style={{ marginTop: "1rem" }}>
          <p>No document metadata definitions found.</p>
        </div>
      ) : (
        <table style={{ marginTop: "1rem", borderCollapse: "collapse", width: "100%" }}>
          <thead>
            <tr>
              <th style={{ border: "1px solid #ccc", padding: "8px", textAlign: "left" }}>ID</th>
              <th style={{ border: "1px solid #ccc", padding: "8px", textAlign: "left" }}>Name</th>
              <th style={{ border: "1px solid #ccc", padding: "8px", textAlign: "left" }}>
                Field Type
              </th>
              <th style={{ border: "1px solid #ccc", padding: "8px", textAlign: "left" }}>
                Description
              </th>
              <th style={{ border: "1px solid #ccc", padding: "8px", textAlign: "left" }}>
                Default Value
              </th>
              <th style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center" }}>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {metadataDefs.map((defn) => (
              <tr key={defn.id}>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {defn.id}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {defn.name}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {defn.fieldType}  {/* Changed from defn.field_type */}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {defn.description || "-"}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {defn.defaultValue || "-"}  {/* Changed from defn.default_value */}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center" }}>
                  <Link to={`/settings/document-metadata-definitions/${defn.id}`}>
                    Edit
                  </Link>{" "}
                  |{" "}
                  <button 
                    onClick={() => handleDelete(defn.id, defn.name)}
                    style={{ 
                      background: 'none', 
                      border: 'none', 
                      color: '#dc3545', 
                      cursor: 'pointer',
                      textDecoration: 'underline'
                    }}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default MetadataDefinitionList;
